<template>
  <div class="aside-box">
    <el-aside width="200px" class="aside-menu">
      <el-menu :default-active="routeName" @select="handleSelect">
        <template v-for="item in trueRoutes">
          <el-submenu :index="item.name" :key="item.path" v-if="item.resourceType === 1">
            <template slot="title">
              <img src="../../assets/icon/workorder.png" alt="">
              <span class="title">{{item.text}}</span>
              <img src="../../assets/icon/workorder.png" alt="">
            </template>
            <el-menu-item v-for="it in item.children" :key="it.path" :index="it.name">{{it.text}}</el-menu-item>
          </el-submenu>
          <template v-if="item.resourceType === 2">
            <el-menu-item :index="item.name" :key="item.path">{{item.text}}</el-menu-item>
          </template>
        </template>
      </el-menu>
    </el-aside>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  export default {
    name: 'AsideMenu',
    methods: {
      handleSelect(key, keyPath) {
        if (this.$route.name == key) {
          return
        }
        if (name === 'Console') {
          this.$router.push('/console')
          return
        }
        this.$router.push({
          name: key
        })
      }
    },
    
    computed: {
      ...mapState('common/promise', ['trueRoutes', 'breadcrumb', 'routeName']),
    },
    created() {
      this.$store.dispatch('common/promise/getPermissions')
      this.$store.dispatch('common/dictionary/setDctByArr')
    }
  }
</script>

<style lang="scss">
  .aside-box {
    height: 100%;

    .aside-menu {
      height: 100%;
      background-color: #404E62;
      overflow-y: auto;
      overflow-x: hidden;

      .el-menu {
        background-color: #404E62;
      }

      .el-submenu__title {
        color: white;
        font-size: 14px;
      }

      .el-menu-item {
        color: white;
        font-size: 14px;
        padding-left: 42px !important;
      }

      .work-bench {
        padding-left: 17px !important;
      }

      .el-submenu .el-menu-item {
        height: 40px;
        line-height: 40px;
      }
      .el-submenu .el-menu-item.is-active {
        background-color: #253142;
      }

      .el-menu-item,
      .el-submenu__title {
        height: 40px;
        line-height: 40px;
      }

      .el-menu-item:focus,
      .el-menu-item:hover {
        background-color: #253142;

        &:before {
          display: block;
        }
      }

      .el-submenu__title:hover,
      .el-submenu__title.is-active{
        background-color: #253142;

        &:before {
          display: block;
        }
      }

      .el-submenu__title {
        padding-left: 17px !important;
      }

      .el-submenu__title,
      .el-menu-item {
        display: flex;
        align-items: center;
        position: relative;

        &:before {
          height: 14px;
          width: 2px;
          position: absolute;
          left: 0;
          top: 13px;
          background-color: #0092FF;
          content: ' ';
          display: none;
        }

        .title {
          display: inline-block;
          width: 93px;
          margin-left: 11px;
        }

        img {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layouts/AsideMenu/AsideMenu.vue